import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DemoService } from '../../../components/demo/demo.service';
import { applyLanguageFromQuery, isSupportedLanguage, Langs, resolveLanguage } from '../../language/_languages';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.scss'],
})
export class ChangeLanguageComponent implements OnInit, OnDestroy {

  langs = Langs;
  currentLanguage: string;
  private querySub: Subscription | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private demoService: DemoService
  ) {
    this.syncFromQuery(this.route.snapshot.queryParamMap);
    this.currentLanguage = resolveLanguage(localStorage.getItem('language'));
  }

  ngOnInit(): void {
    this.querySub = this.route.queryParamMap.subscribe(params => {
      this.syncFromQuery(params);
    });
  }

  ngOnDestroy(): void {
    if (this.querySub) {
      this.querySub.unsubscribe();
    }
  }

  changeLanguage(lang: string): void {
    if (!isSupportedLanguage(lang)) {
      return;
    }
    const previous = this.currentLanguage;
    this.currentLanguage = lang;
    localStorage.setItem('language', lang);

    if (!this.isDemoRoute() || previous === lang) {
      return;
    }

    this.demoService.clearSession();
    const path = this.currentPath();
    if (path === '/demo/complete') {
      this.router.navigate(['/demo'], { queryParams: { lang } });
      return;
    }
    this.router.navigate([], {
      queryParams: { lang },
      queryParamsHandling: 'merge'
    });
  }

  private syncFromQuery(params: ParamMap): void {
    const lang = params.get('lang');
    const language = params.get('language');
    if (this.isDemoRoute()) {
      this.demoService.applyQueryLanguage(lang, language);
      this.currentLanguage = resolveLanguage(localStorage.getItem('language'));
      return;
    }
    if (this.isCredentialRoute()) {
      applyLanguageFromQuery(lang, language);
      this.currentLanguage = resolveLanguage(localStorage.getItem('language'));
    }
  }

  private isDemoRoute(): boolean {
    const path = this.currentPath();
    return path === '/demo' || path.indexOf('/demo/') === 0 || path === '/try';
  }

  /** Login and password-reset share the demo query helper and do not touch a demo session. */
  private isCredentialRoute(): boolean {
    const path = this.currentPath();
    return path === '/login' || path === '/reset-password';
  }

  private currentPath(): string {
    const routerPath = (this.router.url || '').split('?')[0];
    if (routerPath && routerPath !== '/') {
      return routerPath;
    }
    if (typeof window !== 'undefined' && window.location && window.location.pathname) {
      return window.location.pathname;
    }
    return routerPath;
  }
}
